<template>
  <div :id="page.news.$path" v-if="page.news" :class="{'active': currentPage == page.news.$path}">
    <div class="section">
      <div class="section__main reduced-width">
        <PageTitle :isActive="isActive()" :isAnimated="isAnimated" :class="{'static': isAnimated}" :titleValue="page.news.title"></PageTitle>
      </div>
      <div class="news-wrapper" :class="{'static': isAnimated}">
        <div class="swiper-controls">
          <div class="swiper-button-prev icon-arrow-left" slot="button-prev"></div>
          <div class="swiper-button-next icon-arrow-right" slot="button-next"></div>
        </div>
        <swiper :options="swiperOption" ref="mySwiper" class="news-list">
          <swiper-slide v-for="(article, index) in news.item" class="article">
            <span class="article__pointer" :style="`transition-delay: ${(index * 200)/1000}s`"></span>
            <div class="article__inner" @click="setCurrentArticleID(index)" :style="`animation-delay: ${(index * 200)/1000}s`">
              <div class="article__date">
                <span class="article__day" v-if="article.publication_datetime.$day">{{setDay(article.publication_datetime.$day)}}</span>
                <span class="article__monthyear">
                  <span class="article__month">{{$t('months', lang)[parseInt(article.publication_datetime.$month, 10) - 1]}}</span>
                  <span>{{ article.publication_datetime.$year }}</span>
                </span>
              </div>
              <div class="article__summary" v-html="article.text.item.text_summary"></div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <NewsPopup></NewsPopup>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import PageTitle from '@/components/PageTitle';
import NewsPopup from '@/components/NewsPopup';
import prettifyDay from '@/helpers/prettifyDay';

require('@/assets/css/swiper.css');

export default {
  name: 'newsList',
  data() {
    return {
      isAnimated: false,
      swiperOption: {
        direction: 'horizontal',
        speed: 500,
        paginationClickable: true,
        keyboardControl: true,
        grabCursor: true,
        slidesPerView: 3,
        spaceBetween: 0,
        mousewheelControl: false,
        prevButton: '.swiper-button-prev',
        nextButton: '.swiper-button-next',
      },
    };
  },
  components: {
    PageTitle,
    NewsPopup,
  },
  computed: mapGetters({
    lang: 'lang',
    page: 'page',
    currentPage: 'currentPage',
    news: 'news',
  }),
  watch: {
    lang() {
      this.getData();
    },
  },
  methods: {
    isActive() {
      const checkActive = this.currentPage === this.page.news.$path;
      const animationTime = (this.page.news.title.length * 70) + 2000;
      setTimeout(() => {
        if (checkActive) {
          this.isAnimated = true;
        }
      }, animationTime);
      return checkActive;
    },
    slidersNumChange() {
      if (window.innerWidth < 800) {
        this.swiperOption.slidesPerView = 1;
      } else {
        this.swiperOption.slidesPerView = 3;
      }
    },
    setCurrentArticleID(index) {
      this.$store.commit('SET_CURRENT_ARTICLE', index);
      this.$store.commit('SET_POPUP_STATE', true);
    },
    getData() {
      this.$store.dispatch('fetchNews', { lang: this.lang, $http: this.$http });
    },
    setDay(day) {
      return prettifyDay(day);
    },
  },
  mounted() {
    this.slidersNumChange();
    window.addEventListener('resize', this.slidersNumChange);
    this.getData();
  },
  beforeDestroy() {
    window.addEventListener('resize', this.slidersNumChange);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @keyframes articleAnimation {
    0% {
      left: -20px;
      opacity: 0;
    }
    100% {
      left: 0;
      opacity: 1;
    }
  }

  #news {
    .section {
      background: #570803;
      position: relative;
      margin-top: 160px;

      &:before,
      &:after {
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        height: 160px;
      }

      &:before {
        bottom: 100%;
        background: linear-gradient(to bottom, rgba(87, 8, 3, 0) 0%, rgba(87, 8, 3, 1) 100%);
      }

      &:after {
        top: 100%;
        background: linear-gradient(to bottom, rgba(87, 8, 3, 1) 0%, rgba(87, 8, 3, 0) 100%);
      }
    }
  }

  .news-wrapper {
    position: relative;
    padding-top: 180px;
    margin-top: -110px;
  }

  .swiper {
    &-controls {
      position: absolute;
      right: 0;
      top: 0;
      height: 80px;
      z-index: 1;

      .swiper {
        &-button {
          &-next,
          &-prev {
            margin-top: -40px;
            background-image: none;
            width: auto;
            height: auto;
            opacity: 0;
            transition: right 0.3s ease 0.7s, opacity 0.3s ease 0.7s;

            &:before {
              font-size: 36px;
              color: #fff;
              line-height: 100%;
              position: relative;
            }
          }

          &-next {
            right: 70px;

            #news.active .news-wrapper:not(.static) & {
              right: 50px;
              opacity: 1;

              &.swiper-button-disabled {
                opacity: 0.35;
              }
            }

            #news .news-wrapper.static & {
              right: 50px;
              opacity: 1;

              &.swiper-button-disabled {
                opacity: 0.35;
              }
            }

            &:before {
              right: 0;
              transition: right 0.2s ease;
            }

            &:not(.disabled):hover {
              &:before {
                right: -10px;
              }
            }
          }

          &-prev {
            left: auto;
            right: 100px;

            #news.active .news-wrapper:not(.static) & {
              right: 120px;
              opacity: 1;

              &.swiper-button-disabled {
                opacity: 0.35;
              }
            }

            #news .news-wrapper.static & {
              right: 120px;
              opacity: 1;

              &.swiper-button-disabled {
                opacity: 0.35;
              }
            }

            &:before {
              left: 0;
              transition: left 0.2s ease;
            }

            &:not(.disabled):hover {
              &:before {
                left: -10px;
              }
            }
          }
        }
      }
    }
  }

  .news-list {
    position: relative;
    padding: 0 50px;

    &:before {
      content: '';
      border-top: 1px solid $main-color;
      position: absolute;
      top: 0;
      left: 0;
      right: 100%;
      transition: right 0.3s ease;

      #news.active .news-wrapper:not(.static) &,
      #news .news-wrapper.static & {
        right: 0;
      }
    }
  }

  .article {
    white-space: normal;
    display: inline-block;
    vertical-align: top;
    padding: 40px 50px 0 0;
    width: 25%;
    position: relative;

    &__pointer {
      content: '';
      width: 1px;
      height: 0;
      background: $main-color;
      position: absolute;
      top: 0;
      left: 11px;
      transition: height 0.3s ease;

      #news.active .news-wrapper:not(.static) &,
      #news .news-wrapper.static & {
        height: 30px;
      }
    }

    &__inner {
      position: relative;
      left: -20px;
      opacity: 0;

      #news.active .news-wrapper:not(.static) & {
        animation: articleAnimation 0.8s ease-in-out forwards;
      }

      #news .news-wrapper.static & {
        left: 0;
        opacity: 1;
      }

      &:before {
        content: '';
        background-color: rgba(238, 46, 34, 0.2); 
        position: absolute;
        left: -20px;
        top: -10px;
        right: -20px;
        bottom: -20px;
        z-index: -1;
        border-radius: 6px;
        opacity: 0;
        transform: scale(0.9);
        transition: opacity 0.3s ease, transform 0.3s ease;
      }

      &:hover {
        &:before {
          opacity: 1;
          transform: scale(1);
        }
      }
    }

    &__date {
      margin-bottom: 10px;
    }

    &__day {
      font-size: 46px;
      line-height: 100%;
      display: inline-block;
      vertical-align: top;
      margin-right: 5px;
      padding-top: 8px;
      font-family: 'DietDidotTitleBold', Georgia;
    }

    &__monthyear {
      display: inline-block;
      vertical-align: top;
      opacity: 0.6;
      line-height: 150%;

      span {
        display: block;
      }
    }
  }

  @media (max-width: 850px) {
    .news-wrapper {
      position: relative;
      padding-top: 0;
      margin-top: 30px;
    }

    .swiper {
      &-controls {
        display: none;
        position: absolute;
        right: auto;
        left: 20px;
        top: auto;
        bottom: 0;
        width: 160px;

        .swiper {
          &-button {
            &-next {
              right: auto;
              left: 100px;
            }

            &-prev {
              left: 0;
              right: auto;
            }
          }
        }
      }
    }

    .news-list {
      padding: 0 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/News.vue?e611e66a